// extracted by mini-css-extract-plugin
export default {"defaultRouteMain":"defaultRoute_defaultRouteMain__HvVcm","returnLink":"defaultRoute_returnLink__C9ASd","defaultRouteImgContainer":"defaultRoute_defaultRouteImgContainer__GDZpC"};